import React from 'react';
import {  useState } from 'react';
import { Col, Form, Row, Spinner } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { formChangedAction } from '../../actions/index';
import EnlargableTextbox from 'components/common/EnlargableTextbox';

import loader from '../../assets/img/loader.svg'
import FalconComponentCard from 'components/common/FalconComponentCard';
import { ChangePasswordAction } from 'actions/ChangePassword/changePasswordAction';

export const ChangePasswordDetail = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [formHasError, setFormError] = useState(false);

  const changePasswordReducer = useSelector(
    state => state.rootReducer.changePasswordReducer
  );
  const changePasswordData = changePasswordReducer.changePasswordDetails;
  const formChangedReducer = useSelector((state) => state.rootReducer.formChangedReducer)
  var formChangedData = formChangedReducer.formChanged;

  const changePasswordErrorReducer = useSelector(
    state => state.rootReducer.changePasswordErrorReducer
  );
  const changePasswordError = changePasswordErrorReducer.changePasswordDetailError;

  const handleFieldChange = e => {
    dispatch(
      ChangePasswordAction({
        ...changePasswordData,
        [e.target.name]: e.target.value
      })
    );
    dispatch(formChangedAction({
      ...formChangedData,
      changePassword: true
    }))
  };

  return (
    <>
      {/* {isLoading ? (
        <Spinner
  className="loader-color popup-loader position-fixed top-50 start-50 translate-middle z-index-5"
          // className="position-absolute start-50 loader-color"
          animation="border"
        />
      ) : null} */}
            {isLoading ? (
  <img
    src={loader}
    alt="Loading..."
    className="loader-gif position-fixed top-50 start-50 translate-middle z-index-5"
  />
) : null}

      {changePasswordData && (
        <Form
          noValidate
          validated={formHasError}
          className="details-form "
          id="addChangePasswordDetails"
        >
          <FalconComponentCard className="farmer-card-row1 mb-2 change-password-card">
            <FalconComponentCard.Header
              title="Change Password"
              light={false}
            />
            <FalconComponentCard.Body language="jsx">
              <Row className='mb-1'>
                <Col sm={8} lg={8} className="no-pd-card  ">
                  <Row >
                    <Col className="me-3 ms-3">
                      <Form.Group
                        as={Row}
                        // className="mb-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon bold-text">
                          <h5>Old Password<span className="text-danger tc-danger">*</span></h5><span className='advocate-profile-colum-2'>:</span>
                        </Form.Label>
                        <Col sm={5}>
                          <EnlargableTextbox
                            id="txtOldPassword"
                            name="oldPassword"
                            maxLength={50}
                            value={changePasswordData.oldPassword}
                            onChange={handleFieldChange}
                            placeholder="Old Password"
                            required={true}

                          />
                          {Object.keys(changePasswordError.oldPasswordErr).map(key => {
                            return (
                              <span className="error-message">
                                {changePasswordError.oldPasswordErr[key]}
                              </span>
                            );
                          })}
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className='mb-1'>
                <Col md={8} lg={8} className="no-pd-card  ">
                  <Col className="me-3 ms-3">
                    <Form.Group as={Row} controlId="formHorizontalEmail ">
                      <Form.Label column sm={4} className="label-with-colon bold-text">
                        <h5>New Password<span className="text-danger tc-danger">*</span></h5><span className='advocate-profile-colum-2'>:</span>
                      </Form.Label>
                      <Col sm={5}>
                        <EnlargableTextbox
                          id="txtNewPassword"
                          name="newPassword"
                          maxLength={50}
                          value={changePasswordData.newPassword}
                          onChange={handleFieldChange}
                          placeholder="New Password"
                        />
                        {Object.keys(changePasswordError.newPasswordErr).map(key => {
                          return (
                            <span className="error-message">
                              {changePasswordError.newPasswordErr[key]}
                            </span>
                          );
                        })}
                      </Col>
                    </Form.Group>
                  </Col>
                </Col>
              </Row>
              <Row className='mb-1'>
                <Col md={8} lg={8} className="no-pd-card  ">
                  <Col className="me-3 ms-3">
                    <Form.Group as={Row} controlId="formHorizontalEmail ">
                      <Form.Label column sm={4} className="label-with-colon bold-text">
                        <h5>Confirm Password<span className="text-danger tc-danger">*</span></h5><span className='advocate-profile-colum-2'>:</span>
                      </Form.Label>
                      <Col sm={5}>
                        <EnlargableTextbox
                          id="txtConfirmPassword"
                          name="confirmPassword"
                          maxLength={50}
                          value={changePasswordData.confirmPassword}
                          onChange={handleFieldChange}
                          placeholder="Confirm Password"
                        />
                        {Object.keys(changePasswordError.confirmPasswordErr).map(key => {
                          return (
                            <span className="error-message">
                              {changePasswordError.confirmPasswordErr[key]}
                            </span>
                          );
                        })}
                      </Col>
                    </Form.Group>
                  </Col>
                </Col>
              </Row>
            </FalconComponentCard.Body>
          </FalconComponentCard>
        </Form>
      )}
    </>
  );
};

export default ChangePasswordDetail;